import { Layout } from "antd";
import qs from "qs";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

import { Navigate, Outlet } from "react-router-dom";
import useUsers from "../../hooks/useUsers";

import { autoOasisCodeQuery, PATH, speedMateQuery } from "../constants/path";

const NotAuthRoute: React.FC = () => {
  const { checkSignIn } = useUsers();
  const nav = useNavigate();

  const location = useLocation();
  const speedMateCode: string | undefined = qs.parse(location.search)[
    speedMateQuery
  ] as string;
  const autoOasisCode: string | undefined = qs.parse(location.search)[
    autoOasisCodeQuery
  ] as string;
  const isSpeedMate = speedMateCode?.length > 0;
  const isAutoOasis = autoOasisCode?.length > 0;
  useEffect(() => {
    if (isSpeedMate)
      nav(`${PATH.SPEED_MATE_RESERVATION + speedMateQuery}=${speedMateCode}`);
    if (isAutoOasis)
      nav(
        `${PATH.AUTO_OASIS_RESERVATION + autoOasisCodeQuery}=${autoOasisCode}`
      );
  }, [isSpeedMate, isAutoOasis]);
  return !checkSignIn() ? (
    <Layout style={{ backgroundColor: "white", overflowY: "hidden" }}>
      <Outlet />
    </Layout>
  ) : (
    <Navigate to={PATH.RESERVATION} />
  );
};
export default NotAuthRoute;
